import { MtxGrid } from '@meilleurtaux/mtp-uikit-react';
import { useMutation } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { Link, Navigate, useLocation, useNavigate } from 'react-router-dom';

import { postAppAccountPasswordresetInvoke } from '@/api';
import { Loader } from '@/components/Loader/loader';
import { ROUTE } from '@/constants/route';
import { log } from '@/utils/functions/logger/logger';

import styles from './styles.module.css';

export const RedirectionMail: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const email = location.state?.email;

  const mutation = useMutation({
    mutationFn: (emailAddress: string) => postAppAccountPasswordresetInvoke({ email: emailAddress }),
    onError: (error) => {
      log.error(`RedirectionMail mutation failed: ${error}`);
      navigate(ROUTE.ERREUR);
    },
  });

  if (!email) {
    return <Navigate to={ROUTE.LOGIN} replace />;
  }

  const sendNewMail = (e: React.FormEvent) => {
    e.preventDefault();
    mutation.mutate(email);
  };

  return (
    <MtxGrid id={styles.redirectionMail} row>
      <MtxGrid
        id={styles.redirectionMailContent}
        col
        colXs={12}
        offsetXs={0}
        colSm={8}
        offsetSm={2}
        colMd={8}
        offsetMd={2}
        colLg={6}
        offsetLg={3}
        colXl={6}
        offsetXl={3}
      >
        {mutation.isPending && (
          <div>
            <Loader />{' '}
          </div>
        )}
        <h2>{t('redirectionMail.title')}</h2>
        <i className="totem-icon totem-icon-mail-add" />
        <div>
          <p>{t('redirectionMail.wording')}</p>
          <span className={styles.customerEmail}> {email}</span>
        </div>
        <p>{t('redirectionMail.resetLinkInstruction')}</p>
        <p>{t('redirectionMail.checkSpamMessage')}</p>
        <button onClick={sendNewMail} className={styles.linkResetPassword}>
          {t('redirectionMail.linkWording')}
        </button>
        <p className={styles.mailLinks}>
          {t('redirectionMail.passwordFoundMessage')}{' '}
          <Link to={ROUTE.LOGIN} className={styles.linkResetPassword}>
            {t('common.logInText')}
          </Link>
        </p>
      </MtxGrid>
    </MtxGrid>
  );
};
